import React, { Component } from 'react';
import './ChoiceButton.scss';

export class ChoiceButton extends Component {
  render() {
    const { buttonClick, header, index, disabledMessage, subHeader } =
      this.props;
    return (
      <div
        id={`registration-type-${header.replace(/[ |\u00A0]/g, '-')}-${index}`}
        className={`e2e-choice-button ${
          !disabledMessage ? 'college-branded-choice-button' : ''
        } ${
          disabledMessage
            ? 'choice-button choice-button-disabled'
            : 'choice-button'
        }`}
        onClick={() => !disabledMessage && buttonClick()}
      >
        <div className="choice-button-text">
          <p className="choice-button-header">{header}</p>
          <p className="choice-button-sub-header">{subHeader}</p>
          {disabledMessage && (
            <p className="choice-button-sub-info">{disabledMessage}</p>
          )}
        </div>
      </div>
    );
  }
}

export default ChoiceButton;
